import Service from '@ekd/portal-connector/dist/Service';
import { getEnv } from '../../../common/utils/getEnv';
import { isObjectEmpty } from '../../../common/utils/helpers';

import { FetchFeed } from '../types/frontpage';

const isDev = process.env.NODE_ENV === 'development';

class FeedService extends Service {
  /**
   * Fetch feed
   */
  public async fetch(id: string) {
    try {
      const apiProvider = this.createProvider('HTTP');

      const feed = await apiProvider.request<FetchFeed['data']>({
        url: getEnv('feedApi'),
        params: {
          ch: id,
        },
        timeout: isDev ? 0 : 3000,
      });

      if (!feed || !(feed.length > 0)) {
        return null;
      }

      return { id, feed };
    } catch {
      return null;
    }
  }

  /**
   * Loop through feeds synchronously and return multiple feeds filtered by id
   */
  public async fetchTogether(idList: string[]) {
    const response = await Promise.allSettled(idList.map(async (id: string) => this.fetch(id)));

    const result = response.reduce((result: Record<string, FetchFeed['data']>, data) => {
      if (data.status === 'fulfilled' && data.value?.id) {
        const id = data.value.id;
        result[id] = data.value.feed;
      }

      return result;
    }, {});

    return !isObjectEmpty(result) ? result : null;
  }
}

export const feedService = new FeedService();
